import { env as s } from "@fond-of/env";
const e = (t, r) => {
  s.isSSR || window.dispatchEvent(
    new CustomEvent(t, {
      detail: r
    })
  );
}, n = (t, r) => {
  const p = (L) => r(L.detail, L);
  return s.isBrowser && window.addEventListener(t, p), p;
}, o = (t, r) => {
  s.isSSR || window == null || window.removeEventListener(t, r);
}, c = "auth", D = (t) => e(c, t), P = (t) => n(c, t), h = (t) => o(c, t), i = "cart", E = (t) => e(i, t), S = (t) => n(i, t), f = (t) => o(i, t), a = "increase_cart_item", M = (t) => {
  E({ cart: t.cart }), e(a, t);
}, U = (t) => n(a, t), O = (t) => o(a, t), v = "decrease_cart_item", b = (t) => {
  E({ cart: t.cart }), e(v, t);
}, k = (t) => n(v, t), y = (t) => o(v, t), _ = "view_cart", B = (t) => {
  e(_, t);
}, F = (t) => n(_, t), G = (t) => o(_, t), d = "add_cart_code", q = (t) => {
  E({ cart: t.cart }), e(d, t);
}, H = (t) => n(d, t), W = (t) => o(d, t), g = "remove_cart_code", K = (t) => {
  E({ cart: t.cart }), e(g, t);
}, Y = (t) => n(g, t), x = (t) => o(g, t), u = "begin_checkout", A = "add_payment_info", C = "add_shipping_info", R = "purchase", Q = (t) => {
  e(u, t);
}, j = (t) => n(u, t), z = (t) => {
  o(u, t);
}, J = (t) => {
  e(A, t);
}, X = (t) => n(A, t), Z = (t) => {
  o(A, t);
}, $ = (t) => {
  e(R, t);
}, tt = (t) => n(R, t), et = (t) => {
  o(R, t);
}, nt = (t) => {
  e(C, t);
}, ot = (t) => n(C, t), rt = (t) => {
  o(C, t);
}, m = "virtual_page_view", Et = (t) => e(m, t), st = (t) => n(m, t), ct = (t) => o(m, t), N = "apply_list_filters", it = (t) => e(N, t), at = (t) => n(N, t), vt = (t) => o(N, t), T = "login_link_requested", _t = (t) => e(T, t), dt = (t) => n(T, t), gt = (t) => o(T, t), I = "user_registered", ut = (t) => e(I, t), At = (t) => n(I, t), Ct = (t) => o(I, t), V = "product_return", Rt = (t) => e(V, t), mt = (t) => n(V, t), Nt = (t) => o(V, t), l = "download_return_label", Tt = (t) => e(l, t), It = (t) => n(l, t), Vt = (t) => o(l, t);
export {
  H as onAddCartCodeEvent,
  X as onAddPaymentInfoEvent,
  ot as onAddShippingInfoEvent,
  at as onApplyListFiltersEvent,
  P as onAuthEvent,
  j as onBeginCheckoutEvent,
  S as onCartEvent,
  k as onDecreaseCartItemEvent,
  It as onDownloadReturnLabelEvent,
  U as onIncreaseCartItemEvent,
  dt as onLoginLinkRequested,
  mt as onProductReturnEvent,
  tt as onPurchaseEvent,
  Y as onRemoveCartCodeEvent,
  At as onUserRegistered,
  F as onViewCartEvent,
  st as onVirtualPageViewEvent,
  W as removeAddCartCodeEvent,
  Z as removeAddPaymentInfoEvent,
  rt as removeAddShippingInfoEvent,
  vt as removeApplyListFiltersEvent,
  h as removeAuthEvent,
  z as removeBeginCheckoutEvent,
  f as removeCartEvent,
  y as removeDecreaseCartItemEvent,
  Vt as removeDownloadReturnLabelEvent,
  O as removeIncreaseCartItemEvent,
  gt as removeLoginLinkRequested,
  Nt as removeProductReturnEvent,
  et as removePurchaseEvent,
  x as removeRemoveCartCodeEvent,
  Ct as removeUserRegistered,
  G as removeViewCartEvent,
  ct as removeVirtualPageViewEvent,
  n as subscribeEvent,
  q as triggerAddCartCodeEvent,
  J as triggerAddPaymentInfoEvent,
  nt as triggerAddShippingInfoEvent,
  it as triggerApplyListFiltersEvent,
  D as triggerAuthEvent,
  Q as triggerBeginCheckoutEvent,
  E as triggerCartEvent,
  b as triggerDecreaseCartItemEvent,
  Tt as triggerDownloadReturnLabelEvent,
  e as triggerEvent,
  M as triggerIncreaseCartItemEvent,
  _t as triggerLoginLinkRequested,
  Rt as triggerProductReturnEvent,
  $ as triggerPurchaseEvent,
  K as triggerRemoveCartCodeEvent,
  ut as triggerUserRegistered,
  B as triggerViewCartEvent,
  Et as triggerVirtualPageViewEvent,
  o as unsubscribeEvent
};
//# sourceMappingURL=event.js.map
